export const sortingOptions = [
    'Price - Low to High',
    'Price - High to Low',
    'Bestselling',
    'New Arrivals'
];

export const defaultSortType = sortingOptions[0];